var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isActive
    ? _c(
        "div",
        {
          staticClass: "cw-tab",
          attrs: {
            role: "tabpanel",
            id: _vm.id,
            "aria-labelledby": _vm.selectorId,
          },
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }